import { Component, ViewChild, ElementRef } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";

import { GlobalCfgService } from '../../services/globalcfg.service';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { MiscService } from 'src/services/misc.service';
import { RedirectService } from 'src/services/redirect.service';

@Component({
	selector: "rm-signin",
	templateUrl: "./signin.component.html",
	styleUrls: ["./signin.component.scss"],
})
export class SigninComponent {
	@ViewChild("leftDiv", { static: true }) divView: ElementRef;

	signinFormGroup = new FormGroup({
    email: new FormControl(),
    password: new FormControl(),
    keepMeSignedIn: new FormControl()
  });
  subscriptions: any[] = [];
  branding: any;
  message: any;
  manageUrl: any;
  loading: boolean = false;

  constructor(
    private authService: AuthService,
    private globalCfgService: GlobalCfgService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private miscService: MiscService,
    private redirectService: RedirectService
  ) {
    this.redirectService.saveQueryParams();
    // check if user is already loggedin (remember me) 
    let loggedInUser = this.globalCfgService.getLoggedInUser();
    if (
      loggedInUser !== undefined &&
      loggedInUser !== null &&
      Object.keys(loggedInUser).length !== 0
    ) {
      // external loading of signin page.... direct user accordingly
      this.afterUserLoggedInAndUserStateSet(loggedInUser['userId']);
    } else {
      this.subscriptions.push(
        this.route.url.subscribe(url => {
          this.route.queryParamMap.subscribe(val => {
            var cid = val.get("cid");
  
            if (cid) {
              this.miscService.getBranding(cid).subscribe(
                (result: any) => {
                  this.branding = result.data[0];
  
                  this.divView.nativeElement.style.background = "linear-gradient(" + this.branding.color + "," + this.branding.color + "),url(../../" + this.branding.welcomeImg + ") no-repeat";
                }
              );
            }
  
          });
        })
      );
    }
  }

  onSubmit(values) {
    this.loading = true;
    window.localStorage.clear();
    this.authService.login(values).subscribe(
      (response) => {
        this.globalCfgService.setLoggedInUser(response, values.keepMeSignedIn);
        this.afterUserLoggedInAndUserStateSet(response['userId']);
      }, (error) => {
        console.log(error);
        console.log('Login failed!');
        this.loading = false;
      }
    );
  }

  afterUserLoggedInAndUserStateSet(userId) {
    this.userService.getUserDetail(userId).subscribe((result: any) => {
      console.log('SignIn: Setting user: ', result);
      this.globalCfgService.setFullUserObj(result);
      this.router.navigateByUrl('/' + result['role']);
      if (result.role == 'brand-owner') {
        window.localStorage.setItem('gcp', result.gcp);
      }
      this.loading = false;
    });
  }
}
